import { createActions, createReducer } from 'reduxsauce'

const situacoes = [
    { value: '', label: 'Todas' },
    { value: 'A', label: 'Ativo' },
    { value: 'E', label: 'Encerrado' },
    { value: 'R', label: 'Rescindido' },
    { value: 'S', label: 'Suspenso' },
]

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setAdministracaoConsultaContrato: ['administracao'],
    setTipoContratoConsultaContrato: ['tipoContrato'],
    setExercicioContratoConsultaContrato: ['exercicioContrato'],
    setNumeroContratoConsultaContrato: ['numeroContrato'],
    setObjetoContratoConsultaContrato: ['objetoContrato'],
    setNomeContratadoContratoConsultaContrato: ['nomeContratadoContrato'],
    setTipoCompraConsultaContrato: ['tipoCompra'],
    setCnpjConsultaContrato: ['cnpj'],
    setCpfConsultaContrato: ['cpf'],
    setModalidadeConsultaContrato: ['modalidade'],
    setDataValidadeInicialConsultaContrato: ['dataValidadeInicial'],
    setDataValidadeFinalConsultaContrato: ['dataValidadeFinal'],
    setSituacaoConsultaContrato: ['situacao'],
    limpaFiltroConsultaContrato: [],
    receberFiltroConsultaContrato: ['filtroRecebido'],
    setStatusConsultaContrato: ['status'],
})

const INITIAL_STATE = {
    administracao: [],
    tipoContrato: [],
    exercicioContrato: new Date().getFullYear(),
    numeroContrato: '',
    objetoContrato: '',
    nomeContratadoContrato: '',
    tipoCompra: '',
    cnpj: '',
    cpf: '',
    modalidade: [],
    dataValidadeInicial: '',
    dataValidadeFinal: '',
    situacao: { value: situacoes[0].value, label: situacoes[0].label },
    status: { label: '', value: '' },
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setTipoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, tipoContrato: action.tipoContrato }
}

const setExercicioContrato = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioContrato: action.exercicioContrato }
}

const setNumeroContrato = (state = INITIAL_STATE, action) => {
    return { ...state, numeroContrato: action.numeroContrato }
}

const setObjetoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, objetoContrato: action.objetoContrato }
}

const setNomeContratadoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, nomeContratadoContrato: action.nomeContratadoContrato }
}

const setTipoCompra = (state = INITIAL_STATE, action) => {
    return { ...state, tipoCompra: action.tipoCompra }
}

const setCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: action.cnpj }
}

const setCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: action.cpf }
}

const setModalidade = (state = INITIAL_STATE, action) => {
    return { ...state, modalidade: action.modalidade }
}

const setDataValidadeInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataValidadeInicial: action.dataValidadeInicial }
}

const setDataValidadeFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataValidadeFinal: action.dataValidadeFinal }
}

const setSituacao = (state = INITIAL_STATE, action) => {
    return { ...state, situacao: action.situacao }
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ADMINISTRACAO_CONSULTA_CONTRATO]: setAdministracao,
    [Types.SET_TIPO_CONTRATO_CONSULTA_CONTRATO]: setTipoContrato,
    [Types.SET_EXERCICIO_CONTRATO_CONSULTA_CONTRATO]: setExercicioContrato,
    [Types.SET_NUMERO_CONTRATO_CONSULTA_CONTRATO]: setNumeroContrato,
    [Types.SET_OBJETO_CONTRATO_CONSULTA_CONTRATO]: setObjetoContrato,
    [Types.SET_NOME_CONTRATADO_CONTRATO_CONSULTA_CONTRATO]: setNomeContratadoContrato,
    [Types.SET_TIPO_COMPRA_CONSULTA_CONTRATO]: setTipoCompra,
    [Types.SET_CNPJ_CONSULTA_CONTRATO]: setCnpj,
    [Types.SET_CPF_CONSULTA_CONTRATO]: setCpf,
    [Types.SET_MODALIDADE_CONSULTA_CONTRATO]: setModalidade,
    [Types.SET_DATA_VALIDADE_INICIAL_CONSULTA_CONTRATO]: setDataValidadeInicial,
    [Types.SET_DATA_VALIDADE_FINAL_CONSULTA_CONTRATO]: setDataValidadeFinal,
    [Types.SET_SITUACAO_CONSULTA_CONTRATO]: setSituacao,
    [Types.LIMPA_FILTRO_CONSULTA_CONTRATO]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_CONTRATO]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_CONTRATO]: setStatus,
})
